module.exports = __webpack_public_path__ + "static/media/sketching.d1bbb4e7.svg";